function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.187 11.518c0 .163-.03.315-.091.457a1.06 1.06 0 01-.256.365c-.11.102-.237.183-.383.244-.147.06-.3.09-.463.09-.162 0-.315-.028-.457-.084a1.093 1.093 0 01-.37-.244 1.287 1.287 0 01-.257-.365 1.117 1.117 0 01-.006-.895 1.156 1.156 0 01.627-.62c.146-.062.3-.092.463-.092.162 0 .316.03.463.091.146.061.273.142.383.244a1.117 1.117 0 01.347.81zM7.289 8.765l-.432-4.206a1.186 1.186 0 011.18-1.307A1.182 1.182 0 019.21 4.56l-.447 4.206H7.289z",
  fill: "#FFF",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgComponent;